import React from 'react';
// import BecomePro from '../components/BecomePro';

import loadNamespaces from 'next-translate/loadNamespaces';
import BecomePro from '../components/Pricing';
import { VirpPageContext } from './_app';

const BecomeProPage = () => (
  <>
    <BecomePro
      pricingNav
      pricingHeader
      pricingCards
      proFeatures
      friendlyQuestions
      pricingBanner
    />
  </>
);

BecomeProPage.getInitialProps = async (ctx: VirpPageContext) => {
  const getTranslations = await loadNamespaces({
    ...ctx,
    pathname: '/become-pro',
  });
  return { ...getTranslations };
};

export default BecomeProPage;
